import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import styles from './upgradePage.module.css';
import { FcGoogle } from "react-icons/fc";
import Avatar from '@mui/material/Avatar';
import { axiosInstance } from "../../../../lib/axiosInstance";

function UpgradePage() {
  const [contact, setContact] = useState({
    username: "",
    email: "",
    password: ""
  });

  function handleChange(event) {
    //console.log(event.target); //When printed it will print the html tag which triggered the event.
    //In React, event.target is a synthetic representation of the actual DOM element and is wrapped in a synthetic event object.
    //Although it appears as an HTML-like string when printed, it is still an object with various properties and methods.
    //When you destructure const { value, name } = event.target;, it extracts the value and name properties from that synthetic event target object, enabling you to conveniently access the values of the corresponding input element's value and name attributes.
    //I think when the console.log statement is used to print the "event.target" object, react detects it and displays it as the html element which triggered the event using the synthetic event wrapper object.

    const { value, name } = event.target;
    //console.log(value, name);          // Name of the element and the value of the element.

    // Using spread operator made it short.
    setContact((prevValue) => {
      return {
        ...prevValue,
        [name]: value
      };
    });
  }

  async function handleFormSubmit(event) {
    event.preventDefault();   //To prevent the page from refreshing.

    try {
      // Make a POST request to your server
      const response = await axiosInstance.post('/auth/signup', contact);    
      // "axios" is a popular JavaScript library used for making HTTP requests from web browsers or Node.js applications. 
      // It simplifies the process of sending asynchronous HTTP requests to servers and handling responses.
      
      
      // Handle the response as needed.
      //console.log('SignUp Server response:', response.data);
    } catch (error) {
      // Handle errors
      console.error('Error:', error.message);
    }
  };

  return (
    <div className={styles.main_div}>
      <div className={styles.header_div}>
        <p className={styles.nameplate}><span className= {styles.discuss}>Discuss</span><span className= {styles.learn}>learn</span></p>
        <Avatar className={styles.avatar_class} alt="Paul" src='/images/paul.jpg'/>
      </div>

      <div className={styles.panel_div}>
        <h1 className={styles.h1_main_title}>Upgrade to Discusslearn Pro!</h1>

        <div className={styles.plans_div}>
          <div className={styles.free_plan_div}>
            <h2 className={styles.h1_plan_title}>Free</h2>
            <p className={styles.plan_details_p_tag}>- 2 sessions per week.</p>
            <div className={styles.current_plan_label}>
              Current plan
            </div>
          </div>
          <div className={styles.pro_plan_div}>
            <h2 className={styles.h1_plan_title}>Pro</h2>
            <p className={styles.plan_details_p_tag}>- Unilimited sessions.</p>
            <h2 className={styles.plan_cost_h2}>$5/month</h2>
            <p className={styles.plan_details_p_tag}>(billed monthly)</p>
            <Link className={styles.upgrade_button} to="/upgrade_billing">
              Upgrade
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
}

export default UpgradePage;
